const routes = {
    path: 'metodologia',
    name: 'Metodologia',
    component: () => import('./Metodologia.vue'),
    children: [
        {
            path: 'inserir',
            name: 'Metodologia_Inserir',
            component: () => import('./MetodologiaForm.vue'),
            meta: {
                rules: ['SOL-001'],
            },
        },
        {
            path: ':id/atualizar',
            name: 'Metodologia_Atualizar',
            component: () => import('./MetodologiaForm.vue'),
            meta: {
                rules: ['SOL-001'],
            },
        },
    ],
    meta: {
        rules: ['SOL-001'],
    },
};

export default routes;
